module.exports = __webpack_public_path__ + "img/interactive-hero-slider-mitsu.0a52537a.png";